(function () {
  'use strict';

  var priceFilterSelector = [
    '#boost-pfs-filter-tree-pf-p-price',
    '#boost-pfs-filter-tree2-pf-p-price'
  ].join(',');
  var sliderContainerSelector = [
    '#boost-pfs-filter-tree-pf-p-price .boost-pfs-filter-option-range-slider',
    '#boost-pfs-filter-tree2-pf-p-price .boost-pfs-filter-option-range-slider'
  ].join(',');
  var sliderSelector = [
    '#boost-pfs-filter-tree-pf-p-price .boost-pfs-filter-option-range-slider .noUi-handle',
    '#boost-pfs-filter-tree2-pf-p-price .boost-pfs-filter-option-range-slider .noUi-handle'
  ].join(',');
  var applyButtonSelector = [
    '#boost-pfs-filter-tree-pf-p-price .boost-pfs-filter-apply-button',
    '#boost-pfs-filter-tree2-pf-p-price .boost-pfs-filter-apply-button'
  ].join(',');

  function setAttribute(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function getFilterName(handle) {
    var filter = handle.closest('.boost-pfs-filter-option');
    var heading = filter && filter.querySelector('.boost-pfs-filter-option-title-text');
    return heading ? heading.textContent.trim() : 'Range';
  }

  function numberValue(value) {
    var parsed = parseFloat(String(value).replace(/[^0-9.-]/g, ''));
    return Number.isFinite(parsed) ? parsed : null;
  }

  function getRangeEndpoint(rangeValue) {
    return numberValue(Array.isArray(rangeValue) ? rangeValue[0] : rangeValue);
  }

  function getSliderTarget(slider) {
    return slider.matches('.noUi-target') ? slider : slider.querySelector('.noUi-target');
  }

  function syncSliderAria(slider) {
    var target = getSliderTarget(slider);
    var api = target && target.noUiSlider;
    if (!api) return;

    var handles = Array.from(target.querySelectorAll('.noUi-handle'));
    var values = api.get();
    if (!Array.isArray(values)) values = [values];
    values = values.map(numberValue);

    var range = api.options && api.options.range;
    var overallMin = range ? getRangeEndpoint(range.min) : null;
    var overallMax = range ? getRangeEndpoint(range.max) : null;

    handles.forEach(function (handle, index) {
      var currentValue = values[index];
      var currentMin = index > 0 ? values[index - 1] : overallMin;
      var currentMax = index < handles.length - 1 ? values[index + 1] : overallMax;

      setAttribute(handle, 'tabindex', '0');
      setAttribute(handle, 'role', 'slider');
      if (currentValue !== null) {
        setAttribute(handle, 'aria-valuenow', String(currentValue));
        setAttribute(handle, 'aria-valuetext', '$' + currentValue);
      }
      if (currentMin !== null) setAttribute(handle, 'aria-valuemin', String(currentMin));
      if (currentMax !== null) setAttribute(handle, 'aria-valuemax', String(currentMax));
    });
  }

  function enhanceSlider(slider) {
    var handles = slider.querySelectorAll('.noUi-handle');

    handles.forEach(function (handle, index) {
      var boundary = handles.length > 1 && index === 0 ? 'minimum' :
        handles.length > 1 ? 'maximum' : 'value';

      // Boost can recreate the noUiSlider handles during a filter refresh, so
      // restore their focusability, semantics, and explicit accessible names.
      setAttribute(handle, 'tabindex', '0');
      setAttribute(handle, 'role', 'slider');
      setAttribute(handle, 'aria-label', getFilterName(handle) + ' ' + boundary);
      setAttribute(
        handle,
        'aria-orientation',
        slider.classList.contains('noUi-vertical') ? 'vertical' : 'horizontal'
      );
    });

    syncSliderAria(slider);

    var target = getSliderTarget(slider);
    if (target && target.noUiSlider && !target._greenpanAccessibilityUpdate) {
      target._greenpanAccessibilityUpdate = true;
      target.noUiSlider.on('update.greenpanAccessibility', function () {
        syncSliderAria(slider);
      });
    }

    // Boost can remove the handle tabindex at the end of noUiSlider setup.
    // Restore it after that initialization cycle as well as during updates.
    if (!slider._greenpanFocusabilityScheduled) {
      slider._greenpanFocusabilityScheduled = true;
      window.requestAnimationFrame(function () {
        slider._greenpanFocusabilityScheduled = false;
        slider.querySelectorAll('.noUi-handle').forEach(function (handle) {
          setAttribute(handle, 'tabindex', '0');
        });
        syncSliderAria(slider);
      });
    }
  }

  function enhanceSliders(root) {
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;

    if (root.matches && root.matches(sliderContainerSelector)) {
      enhanceSlider(root);
    } else if (root.matches && root.matches(sliderSelector)) {
      enhanceSlider(root.closest('.boost-pfs-filter-option-range-slider'));
    }

    root.querySelectorAll(sliderContainerSelector).forEach(enhanceSlider);
  }

  function enhanceApplyButtons(root) {
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;

    if (root.matches && root.matches(applyButtonSelector)) {
      setAttribute(root, 'type', 'button');
    }
    root.querySelectorAll(applyButtonSelector).forEach(function (button) {
      setAttribute(button, 'type', 'button');
    });
  }

  function observePriceFilter(priceFilter) {
    if (priceFilter._greenpanAccessibilityObserver) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.target.matches(sliderSelector) &&
          mutation.target.getAttribute('tabindex') !== '0') {
          enhanceSlider(mutation.target.closest('.boost-pfs-filter-option-range-slider'));
        }
      });
    });

    observer.observe(priceFilter, {
      attributes: true,
      subtree: true,
      attributeFilter: ['tabindex']
    });
    priceFilter._greenpanAccessibilityObserver = observer;
  }

  function discoverPriceFilters(root) {
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;

    if (root.matches && root.matches(priceFilterSelector)) observePriceFilter(root);
    root.querySelectorAll(priceFilterSelector).forEach(observePriceFilter);
  }

  function processAddedNode(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;

    var belongsToPriceFilter = node.matches(priceFilterSelector) ||
      node.closest(priceFilterSelector) ||
      node.querySelector(priceFilterSelector);
    if (!belongsToPriceFilter) return;

    discoverPriceFilters(node);
    enhanceSliders(node);
    enhanceApplyButtons(node);
  }

  function adjustSliderFromKeyboard(handle, event) {
    var slider = handle.closest('.boost-pfs-filter-option-range-slider');
    var target = slider && getSliderTarget(slider);
    var api = target && target.noUiSlider;
    if (!api) return false;

    var handles = Array.from(target.querySelectorAll('.noUi-handle'));
    var handleIndex = handles.indexOf(handle);
    if (handleIndex < 0) return false;

    var values = api.get();
    if (!Array.isArray(values)) values = [values];
    values = values.map(numberValue);

    var range = api.options && api.options.range;
    var overallMin = range ? getRangeEndpoint(range.min) : null;
    var overallMax = range ? getRangeEndpoint(range.max) : null;
    var step = numberValue(api.options && api.options.step);
    if (!step || step <= 0) step = 1;

    var currentValue = values[handleIndex];
    var allowedMin = handleIndex > 0 ? values[handleIndex - 1] : overallMin;
    var allowedMax = handleIndex < handles.length - 1 ? values[handleIndex + 1] : overallMax;
    var nextValue = currentValue;

    if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
      nextValue -= step;
    } else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
      nextValue += step;
    } else if (event.key === 'PageDown') {
      nextValue -= step * 10;
    } else if (event.key === 'PageUp') {
      nextValue += step * 10;
    } else if (event.key === 'Home') {
      nextValue = allowedMin;
    } else if (event.key === 'End') {
      nextValue = allowedMax;
    } else {
      return false;
    }

    if (currentValue === null || allowedMin === null || allowedMax === null) return false;

    nextValue = Math.max(allowedMin, Math.min(allowedMax, nextValue));
    values[handleIndex] = nextValue;
    api.set(values);
    syncSliderAria(slider);
    return true;
  }

  function init() {
    discoverPriceFilters(document);
    enhanceSliders(document);
    enhanceApplyButtons(document);

    document.querySelectorAll('.boost-pfs-filter-tree').forEach(function (filterTree) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            processAddedNode(node);
          });
        });
      }).observe(filterTree, {
        childList: true,
        subtree: true
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.target.matches(applyButtonSelector) &&
        (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        event.target.click();
        return;
      }

      if (!event.target.matches(sliderSelector)) return;
      if (!adjustSliderFromKeyboard(event.target, event)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
